// extracted by mini-css-extract-plugin
export default {"stepIcon":"MealPlanningWizard_stepIcon__RD9YE"};